import { OpenNewTabTargetType } from "@voltmoney/types";
import { navigateByUrl, sideBarNavigate } from "../partnerWeb_Dashboard/utils";
import { ROUTE } from "../../routes";
import { StoreKey } from "../../configs/api";
import { VoltWebSiteBaseLink } from "../../configs/constants";
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    await sideBarNavigate(standardUtilities, action);
};
export const openMenu = async (action, _datastore, { navigate }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await navigate(ROUTE.PARTNER_MENU, {
        routeId: action.routeId
    });
};
export const promoBannerInvite = async (action, _datastore, { openNewTab, instrumentTrack }) => {
    instrumentTrack("COLLATERAL_REQUEST_INITIATED", {
        "page": "collateral"
    });
    console.warn('**** promoBannerInvite Action Triggered ****', action);
    openNewTab(`https://wa.me/919611749295?text=Kindly%20provide%20me%20with%20personalized%20co-branded%20marketing%20materials%20to%20help%20educate%20my%20clients.`, OpenNewTabTargetType.blank);
};
export const goToRegister = async (action, _datastore, { navigate, openNewTab, asyncStorage }) => {
    console.warn('**** goToRegister leads Action Triggered ****', action);
    await asyncStorage.set(StoreKey.U_DATA, JSON.stringify(action?.payload?.data?.data?.user_data));
    await navigateByUrl(ROUTE.PARTNER_LEAD, openNewTab);
};
export const onShareLinkRef = async (action, _datastore, { navigate, openNewTab, asyncStorage }) => {
    console.warn('**** onShareLinkRef leads Action Triggered ****', action);
    const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerCode = _user?.linkedPartnerAccounts[0]?.partnerCode;
    await navigate(ROUTE.INVITE_CLIENT, {
        _link: `${VoltWebSiteBaseLink}check-loan-eligibility-against-mutual-funds?ref=${partnerCode}`,
        _headerTitle: 'Share with your customer',
        _title: 'Share the link directly with your client, through a WhatsApp group, or publicly.',
        _bannerTitle: 'We will link your customers to your account if they check limit using your invite link.'
    });
};
